var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstituteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.702,
    height: 40.702,
    viewBox: "0 0 40.702 40.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93457",
    "data-name": "Path 93457",
    d: "M21.351,1A20.351,20.351,0,1,0,41.7,21.351,20.354,20.354,0,0,0,21.351,1Zm9.713,27.289-2.775,2.775-6.938-6.938-6.938,6.938-2.775-2.775,6.938-6.938-6.938-6.938,2.775-2.775,6.938,6.938,6.938-6.938,2.775,2.775-6.938,6.938Z",
    transform: "translate(-1 -1)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituteCross);
export default __webpack_public_path__ + "static/media/InstituteCross.76b290763c8a2c6d9bfff94e2fff5dfb.svg";
export { ForwardRef as ReactComponent };